import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import { mountLoadingSpinner, updateLoadingSpinner } from '../../components/loadingSpinner';
import { HtmlId, NameSpace } from '../../enum';
import * as actionMap from './action';
import appReducer from './reducer';
import appSaga from './saga';
import { mapStateToProps } from './selector';
import { getUpdateFlags } from './update';
import { mountOfferSummaryCard, updateOfferSummaryCard } from '../../components/offerSummaryCard';
import { mountRelatedLinks } from '../../components/relatedLinks';
import { mountAccordion } from '../../components/accordion';
import { TrackingUIType } from '../../tracking/enum';
import { initFootnotes } from '../../components/footnote';
import { mountIcontTextBanner } from '../../components/iconTextBanner';

export type StateProps = ReturnType<typeof mapStateToProps>;
export type Actions = typeof actionMap;

function appContainer(_state: StateProps, actions: Actions) {
    injectSaga(NameSpace.APP, appSaga);
    injectReducer(NameSpace.APP, appReducer);

    const loadingSpinner = mountLoadingSpinner(HtmlId.LOADING);
    const offerSummaryCard = mountOfferSummaryCard(HtmlId.OFFER_SUMMARY_CARD);
    const accordion = mountAccordion(HtmlId.FOOTNOTE_ACCORDION, TrackingUIType.Footnote);

    mountRelatedLinks(HtmlId.RELATED_OFFER_LINKS);
    mountRelatedLinks(HtmlId.RELATED_OTHER_LINKS);
    mountAccordion(HtmlId.FAQ_ACCORDION, TrackingUIType.Faq);
    mountIcontTextBanner(HtmlId.ICON_TEXT_BANNER);
    initFootnotes(accordion);

    actions.getProductDetails();

    return {
        getDerivedStateFromProps(newState: StateProps, oldState: StateProps) {
            const update = getUpdateFlags(newState, oldState);

            update.loading && updateLoadingSpinner(loadingSpinner, newState.loading);
            update.offerSummaryCard && updateOfferSummaryCard(offerSummaryCard, newState.product);
            update.footnotes && initFootnotes(accordion);
        },
    };
}

export default connect(mapStateToProps, actionMap)(appContainer);
